/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';
import { t } from 'utils/translates';

class RoomsListRightSidebar extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="page-sidebar-sticky">
          <div className="page-sidebar-sticky-wrp">
            <PopUpLink
              hashName="messengerGroupRoomFormPopUp"
              className="btn btn-primary btn-block m-b-20"
            >
              <i className="fa fa-plus-circle" /> {t('Создать группу')}
            </PopUpLink>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default RoomsListRightSidebar;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyMessages/RoomsList/RoomsListRightSidebar.js